import dayjs from "./dayjs";

export function minutesToISO8601Duration(minutes: number): string {
  return dayjs.duration(minutes, "minutes").toISOString();
}

export function ISO8601DurationToMinutes(duration: string): number {
  const minutes = dayjs.duration(duration).asMinutes();
  if (isNaN(minutes)) return 0;
  return Math.round(minutes);
}
